const cancelError = Object.freeze(new Error('Cancelled'));

export default cancelError;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isCancel(obj: any) {
  return obj === cancelError;
}
